    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { Inject } from 'vue-di-container';
    import WithRender from './SuggestionsDetails.html';
    import { SuggestionsAndSystemEnhancementListItem, SuggestionsAndSystemEnhancementModel } from '../SuggestionsAndSystemEnhancementModel';
    import { Toaster } from '../../../Services/toast';
    import LoaderService from '../../../Services/LoaderService';
    import SuggestionsAndSystemEnhancementService from '../SuggestionsAndSystemEnhancementService';
    import UserService from '../../../shared/userService/UserService';
    import UserModel from '../../../shared/userService/Model/UserModel';
    import { ProviderModel } from '../../Provider/ProviderModel';
    import ProviderService from '../../Provider/ProviderService';
    import { SuggestionServiceType } from '../SuggestionServiceType';

    @WithRender
    @Component({
      components: {
      },
      diProvide: [
        SuggestionsAndSystemEnhancementService,
        LoaderService,
        UserService,
        ProviderService,
      ],
    })
    export default class SuggestionsDetails extends Vue {
      @Inject(SuggestionsAndSystemEnhancementService) public SuggestionsAndSystemEnhancementService!: SuggestionsAndSystemEnhancementService;
      @Inject(LoaderService) public loaderService!: LoaderService;
      @Inject(UserService) public userService!: UserService;
      @Inject(ProviderService) public providerService!: ProviderService;
      @Prop({ type: Boolean, default: false })
      public layoutSup: boolean | any;

      public suggestion: SuggestionsAndSystemEnhancementListItem = {
        id: '',
        providerName: '',
        service: 0,
        title: '',
        description: '',
        createdDate: ''
      };

      public serviceName: string = '';

      public async mounted() {
        const id = this.$route.params.id;
        if (id) {
          await this.fetchSuggestion(id);
        } else {
          Toaster.error(this.$t('shared.errorSystem').toString());
        }
      }

      private async fetchSuggestion(id: string) {
        this.loaderService.ShowLoader();
        try {
          const resp = await this.SuggestionsAndSystemEnhancementService.getById(id);
          this.loaderService.HideLoader();
          if (resp.isSuccess) {
            this.suggestion = resp.result as SuggestionsAndSystemEnhancementListItem;
            this.serviceName = this.mapService(this.suggestion.service);
          } else {
            Toaster.error(resp.errorMessage);
          }
        } catch {
          this.loaderService.HideLoader();
          Toaster.error('Error fetching suggestion');
        }
      }

      private mapService(id: number): string {
        switch (id) {
          case SuggestionServiceType.NewService: return 'New Service';
          case SuggestionServiceType.SenderNameRegistration: return 'Sender Name Registration';
          case SuggestionServiceType.ContractRequest: return 'Contract Request';
          case SuggestionServiceType.RenewalRequest: return 'Renewal Request';
          case SuggestionServiceType.ConnectivityRequest: return 'Connectivity Request';
          case SuggestionServiceType.Payment: return 'Payment';
          default: return '-';
        }
      }
    }